rdefine('app/categories/selector',['backbone','app/products/collections/CategoriesForCats','app/products/components/CategoryItem'],function(Backbone,Categories,CategoryItem) {

    return Backbone.Ribs.View.extend({
        tagName:'div',
        categories:null,
        bindings:{
            el:{
                collection:{
                    col:'categories',
                    view:CategoryItem
                }
            }
        },
        initialize:function(options) {
            this.categories = new Categories([],{category_id:options.category_id,current_id:options.current_id});
            var $inp = $("<input>");
            $inp.attr("name","parent_id_ex");
            $inp.attr("type","hidden");
            $inp.val(options.category_id);
            this.categories.on("select",function(id) {
                $inp.val(id);
            });
            this.$el.closest("form").append($inp);
        }
    });
});